/* Theme UX only. A public validation app / supported server-side rule is required at checkout.
   No tax arithmetic, no replacement /cart/add request, no persistent browser consent. */
(() => {
  const runtime = document.getElementById('SunpuraVatRuntime');
  if (!runtime || window.SunpuraVAT) return;
  const dialog = runtime.querySelector('dialog');
  const strings = JSON.parse(runtime.querySelector('[data-sp-vat-strings]').textContent);
  const check = dialog.querySelector('[data-sp-vat-check]');
  const confirm = dialog.querySelector('[data-sp-vat-confirm]');
  const error = dialog.querySelector('[data-sp-vat-error]');
  const version = runtime.dataset.version;
  const isDE = runtime.dataset.country === 'DE';
  const fields = {'0% MwSt. bestätigt':'Ja', 'Erklärungsversion':version, '_sp_vat_country':'DE'};
  let task = null, busy = false, activeForm = null;
  const permitted = new WeakSet();
  const controllerFor = form => {
    const root = form.closest('product-info');
    return root?.querySelector('sunpura-pdp-configurator') || root?.querySelector('s2400-configurator');
  };
  const selectedAddons = form => [...(form.closest('product-info')?.querySelectorAll('[data-sp-vat-addon="true"]:checked:not(:disabled)') || [])];
  const required = form => isDE && (form.querySelector('[data-sp-vat-required]') || selectedAddons(form).length);
  const signature = form => {
    const data = new FormData(form);
    const addons = controllerFor(form)?.getState?.().items || [];
    return JSON.stringify([data.get('id'), data.get('quantity') || '1', data.get('selling_plan'), addons.map(x => [x.id,x.quantity])]);
  };
  window.SunpuraVAT = {addonProperties: form => activeForm === form ? {...fields} : {}};
  function stop(event) {event.preventDefault(); event.stopImmediatePropagation();}
  function showError(message) {error.textContent = message; error.hidden = false;}
  function showSelection(form) {
    const node=dialog.querySelector('[data-sp-vat-selection]');
    const controller=controllerFor(form);
    const data=new FormData(form);
    const selected=form.querySelector('select[name="id"]')?.selectedOptions[0]?.textContent;
    const title=controller?.variant?.title || selected || form.closest('product-info')?.querySelector('h1')?.textContent.trim() || '';
    const addons=controller?.getState?.().items.map(x=>x.title) || [];
    node.textContent=[title ? `${title} × ${data.get('quantity') || '1'}` : '',...addons].filter(Boolean).join(' · ');
    node.hidden=!node.textContent;
  }
  function open(next, trigger) {
    if (busy) return;
    task = {...next, trigger};
    check.checked = false; error.hidden = true; confirm.disabled = true;
    dialog.querySelector('.sp-vat-details').open = false;
    const informationOnly = next.mode === 'details';
    dialog.querySelector('[data-sp-vat-check-row]').hidden = informationOnly;
    confirm.hidden = informationOnly;
    confirm.textContent = next.mode === 'cart' ? strings.cart : strings.add;
    dialog.querySelector('[data-sp-vat-selection]').hidden=true;
    if (next.form) showSelection(next.form);
    if (!dialog.open) dialog.showModal();
  }
  function setProperties(form) {
    // Keep all existing product customizations; only replace our three declaration fields.
    for (const [key,value] of Object.entries(fields)) {
      const name = `properties[${key}]`;
      let input = [...form.elements].find(el => el.name === name);
      if (!input) {input=document.createElement('input'); input.type='hidden'; input.name=name; form.append(input);}
      input.value=value;
    }
  }
  async function getCart() {
    const response = await fetch(runtime.dataset.cartUrl + '.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(strings.error);
    return response.json();
  }
  async function updateCart(panel, clear) {
    const expected = JSON.parse(panel.querySelector('[data-sp-vat-cart-lines]').textContent);
    let cart = await getCart();
    const fingerprint = lines => JSON.stringify(lines.map(x => [x.key,x.quantity]));
    if (fingerprint(cart.items) !== fingerprint(expected)) throw new Error(strings.changed);
    const targets = expected.filter(x => clear ? cart.items.find(y => y.key === x.key)?.properties?._sp_vat_country === 'DE' : x.required);
    for (const target of targets) {
      const item = cart.items.find(x => x.key === target.key);
      // Shopify may merge equivalent lines after a property change. Fail safely on any other change.
      if (!item) {
        if (!clear && cart.items.some(x => x.variant_id === target.id && x.properties?.['Erklärungsversion'] === version && x.properties?.['0% MwSt. bestätigt'] === 'Ja' && x.properties?._sp_vat_country === 'DE')) continue;
        throw new Error(strings.changed);
      }
      const properties = {...item.properties};
      for (const [key,value] of Object.entries(fields)) properties[key] = clear ? '' : value;
      const response = await fetch(runtime.dataset.cartChangeUrl + '.js', {
        method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({id:item.key, quantity:item.quantity, properties})
      });
      if (!response.ok) throw new Error(strings.error);
      cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error(strings.error);
    }
    window.location.reload();
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const card = form.closest('[data-sp-vat-product-link]');
    if (card) {stop(event); window.location.assign(card.dataset.spVatProductLink); return;}
    if (event.submitter?.name === 'checkout') {
      const panel = document.querySelector('[data-sp-vat-cart][data-blocked="true"]');
      if (panel) {stop(event); panel.scrollIntoView({block:'center'}); panel.querySelector('button')?.focus();}
      return;
    }
    if (!required(form)) return;
    if (permitted.has(form)) {permitted.delete(form); return;}
    const controller = controllerFor(form);
    if (controller && (controller.pending || controller.failed || controller.config.buy_enabled === false)) {stop(event); return;}
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    stop(event);
    if (submitter?.disabled || submitter?.getAttribute('aria-disabled') === 'true') return;
    open({mode:'add', form, submitter, signature:signature(form)}, submitter);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    const card = target.closest('[data-sp-vat-product-link]');
    if (card && (target.name === 'quickView' || target.name === 'add' || target.matches('[type="submit"]'))) {
      stop(event); window.location.assign(card.dataset.spVatProductLink); return;
    }
    if (target.matches('[data-sp-vat-details]')) {open({mode:'details'}, target); return;}
    if (target.matches('[data-sp-vat-cart-confirm]')) {open({mode:'cart', panel:target.closest('[data-sp-vat-cart]')}, target); return;}
    if (target.matches('[data-sp-vat-close]')) {if (!busy) dialog.close(); return;}
    if (target.matches('[data-sp-vat-clear]')) {
      if (busy) return;
      busy=true; target.disabled=true;
      const panel=target.closest('[data-sp-vat-cart]');
      const message=panel.querySelector('[data-sp-vat-cart-error]'); message.hidden=true;
      updateCart(panel,true).catch(e => {message.textContent=e.message; message.hidden=false;}).finally(() => {busy=false; target.disabled=false;});
    }
  }, true);
  check.addEventListener('change', () => {confirm.disabled = !check.checked || busy;});
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const nodes=[...dialog.querySelectorAll('a[href],summary,button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])')].filter(el=>el.getClientRects().length && !el.closest('[hidden]'));
    const first=nodes[0],last=nodes[nodes.length-1];
    if (!first) {event.preventDefault(); return;}
    if (event.shiftKey && (document.activeElement===first || document.activeElement===dialog)) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement===last) {event.preventDefault();first.focus();}
  });
  dialog.addEventListener('cancel', event => {if (busy) event.preventDefault();});
  dialog.addEventListener('close', () => {const trigger=task?.trigger; task=null; if (trigger?.isConnected) trigger.focus();});
  confirm.addEventListener('click', async () => {
    if (!check.checked || !task || busy) return;
    if (!version || !runtime.querySelector('.sp-vat-declaration').textContent.trim()) {showError(strings.error); return;}
    if (task.mode === 'add') {
      const {form,submitter} = task;
      const controller = controllerFor(form);
      if (!form.isConnected || signature(form) !== task.signature || controller?.pending || controller?.failed || submitter?.disabled || submitter?.getAttribute('aria-disabled') === 'true') {
        if (form.isConnected) {task.signature=signature(form); showSelection(form);}
        showError(strings.changed); check.checked=false; confirm.disabled=true; return;
      }
      if (form.querySelector('[data-sp-vat-required]')) setProperties(form);
      dialog.close();
      // The native form still owns loading, errors, drawer, quantities, variants and add-ons.
      activeForm=form; permitted.add(form);
      try {form.requestSubmit(submitter?.form === form ? submitter : undefined);}
      finally {activeForm=null; permitted.delete(form);}
    } else if (task.mode === 'cart') {
      busy=true; confirm.disabled=true; confirm.textContent=strings.busy;
      try {await updateCart(task.panel,false);}
      catch (e) {showError(e.message);}
      finally {busy=false; confirm.textContent=strings.cart; confirm.disabled=!check.checked;}
    }
  });
})();
